var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_412_115",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.25H0V20.25H20V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_412_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6 10.4773C19.6 9.76819 19.5364 9.08639 19.4182 8.43179H10V12.3H15.3818C15.15 13.55 14.4455 14.6091 13.3864 15.3182V17.8273H16.6182C18.5091 16.0864 19.6 13.5227 19.6 10.4773Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.25C12.7 20.25 14.9636 19.3545 16.6181 17.8273L13.3863 15.3182C12.4909 15.9182 11.3454 16.2727 10 16.2727C7.3954 16.2727 5.1909 14.5136 4.4045 12.15H1.0636V14.7409C2.7091 18.0091 6.0909 20.25 10 20.25Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4045 12.15C4.2045 11.55 4.0909 10.9091 4.0909 10.25C4.0909 9.59089 4.2045 8.94999 4.4045 8.34999V5.75909H1.0636C0.3864 7.10909 0 8.63639 0 10.25C0 11.8636 0.3864 13.3909 1.0636 14.7409L4.4045 12.15Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.2273C11.4681 4.2273 12.7863 4.7318 13.8227 5.7227L16.6909 2.8545C14.9591 1.2409 12.6954 0.25 10 0.25C6.0909 0.25 2.7091 2.4909 1.0636 5.7591L4.4045 8.35C5.1909 5.9864 7.3954 4.2273 10 4.2273Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.28781cfd2d3b0d8142760ab3ca488580.svg";
export { ForwardRef as ReactComponent };